import _extends from "@babel/runtime/helpers/extends";
import { CycleUtils } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { useCycleName, useRevShare } from '../../hooks';
import { useCurrentModule } from '../ModuleProvider';
import { CycleSelectorBadgeUi } from './CycleSelectorBadgeUi';
export const CycleSelectorBadge = _ref => {
  var _product$pricingDetai;
  let {
    productId,
    cycle,
    isSelected,
    shouldShowTooltip,
    ...uiProps
  } = _ref;
  const module = useCurrentModule();
  const {
    getRevShareAmountPerCycle
  } = useRevShare();
  const {
    t,
    Trans
  } = module.internals.useTranslations();
  const formatPrice = module.SDK.useFormatPrice();
  const {
    isLoading: isProductLoading,
    data: product
  } = module.SDK.studioOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const cycleName = useCycleName({
    cycle,
    lowerCase: true
  });
  const monthlyCycleName = useCycleName({
    cycle: {
      cycleDuration: {
        unit: PurchaseOffering.DurationUnit.MONTH,
        count: 1
      }
    },
    lowerCase: true
  });
  if (isProductLoading) {
    return null;
  }
  const revShareAmount = getRevShareAmountPerCycle(cycle);
  if (revShareAmount > 0) {
    const text = t('cycle_entry.revshare_amount.label', {
      amountEarned: formatPrice(revShareAmount)
    });
    return /*#__PURE__*/React.createElement(CycleSelectorBadgeUi, _extends({
      text: text,
      isSelected: isSelected,
      skin: "studio",
      padding: "4px 8px"
    }, uiProps));
  }
  const cycleSavings = formatPrice(Number(product == null || (_product$pricingDetai = product.pricingDetails) == null || (_product$pricingDetai = _product$pricingDetai.find(pricingDetail => CycleUtils.isCycleEqual(pricingDetail.cycle, cycle))) == null || (_product$pricingDetai = _product$pricingDetai.savings) == null || (_product$pricingDetai = _product$pricingDetai.fixedAmount) == null ? void 0 : _product$pricingDetai.amount), {
    hideDecimalPlaces: true
  });
  if (cycleSavings) {
    const text = /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "cycle_entry.cycle_discount",
      values: {
        discount: cycleSavings
      },
      components: {
        1: /*#__PURE__*/React.createElement(React.Fragment, null)
      }
    });
    const tooltipContent = shouldShowTooltip ? t('cycle_entry.second_upgrade.save_badge_tooltip', {
      amount: cycleSavings,
      recommendedCycle: cycleName,
      currentCycle: monthlyCycleName
    }) : undefined;
    return /*#__PURE__*/React.createElement(CycleSelectorBadgeUi, _extends({
      text: text,
      isSelected: isSelected,
      skin: "default",
      tooltipContent: tooltipContent
    }, uiProps));
  }
  return null;
};
//# sourceMappingURL=CycleSelectorBadge.js.map